export var DialogFooterAlignment;
(function (DialogFooterAlignment) {
    DialogFooterAlignment[DialogFooterAlignment["Left"] = 1] = "Left";
    DialogFooterAlignment[DialogFooterAlignment["Center"] = 2] = "Center";
    DialogFooterAlignment[DialogFooterAlignment["Right"] = 3] = "Right";
})(DialogFooterAlignment || (DialogFooterAlignment = {}));
//# sourceMappingURL=dialog_service.js.map